// @ts-nocheck
import React, { FC, forwardRef, useRef } from "react";
import { SignatureComponent } from "@syncfusion/ej2-react-inputs";
import css from "./index.module.css";

const SignDraw: FC<any> = forwardRef(({ setCreatedSignature }: any, ref) => {
  const signDrawRef: any = ref || useRef(null);

  const saveBtnClick = () => {
    setCreatedSignature(signDrawRef.current.getSignature());
  };
  return (
    <SignatureComponent
      ref={signDrawRef}
      id="signature"
      className={css.signWrapper}
      change={saveBtnClick}
      saveWithBackground={false}
    />
  );
});
SignDraw.displayName = "SignDraw";
export default SignDraw;
